import { render, staticRenderFns } from "./index.vue?vue&type=template&id=24887251&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=24887251&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseOrnamentBg: require('/opt/airport.kg/src/components/base/ornament-bg.vue').default,BaseHeaderDrawerBlock: require('/opt/airport.kg/src/components/base/header/drawer/block.vue').default,ServiceMainCard: require('/opt/airport.kg/src/components/service/main/card.vue').default})
